<template>
  <div :class="clsx('comparison-wrapper', { 'animations-disabled': !animationEnabled })">
    <BackgroundGridBlue class="comparison-grid">
      <IntersectionObserver
        class="comparison-observer"
        :animation-enabled="animationEnabled"
        once-class="comparison-observer--visible"
        :once="true"
        :threshold="0.4"
      >
        <FeaturesList
          class="comparison-before-list"
          :animation-enabled="animationEnabled"
          title="Було"
          list-type="simple"
          :items="getBeforeItems"
          :image-components="getBeforeImageComponents"
        />
        <FeaturesList
          class="comparison-ukasko-list"
          :animation-enabled="animationEnabled"
          title="Стало з UConnect"
          list-type="fancy"
          :items="getUkaskoItems"
          :image-components="getUkaskoItemsImageComponents"
        />
      </IntersectionObserver>
      <div class="comparison__footer"></div>
    </BackgroundGridBlue>
  </div>
</template>

<script>
import clsx from 'clsx';
import FeaturesList from '../features-list';
import { textBlock } from '@/entities/text-block';
import { IntersectionObserver } from '@/shared/ui/intersection-observer';
import { BackgroundGridBlue } from '@/shared/ui/promo';
import {
  AbacusImage,
  BellImage,
  BookmarkTabsImage,
  BustsInSilhouetteImage,
  ChartIncreasingImage,
  CryingFaceImage,
  LaptopImage,
  MoaiImage,
  MoneyBagImage,
  MoneyWithWingsImage,
  StarStruckImage,
  TornadoImage,
} from '@/shared/ui/promo';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [ textBlock ],
  components: { BackgroundGridBlue, FeaturesList, IntersectionObserver },
  computed: {
    getBeforeImageComponents() {
      return {
        TornadoImage,
        CryingFaceImage,
        AbacusImage,
        BookmarkTabsImage,
        MoneyWithWingsImage,
        MoaiImage,
      };
    },
    getUkaskoItemsImageComponents() {
      return {
        LaptopImage,
        BellImage,
        ChartIncreasingImage,
        StarStruckImage,
        MoneyBagImage,
        BustsInSilhouetteImage
      };
    },
    getBeforeItems() {
      return [
        {
          icon: 'TornadoImage',
          text: this.getListBlock('promo', 'connect-features-before')[0],
        },
        {
          icon: 'CryingFaceImage',
          text: this.getListBlock('promo', 'connect-features-before')[1],
        },
        {
          icon: 'AbacusImage',
          text: this.getListBlock('promo', 'connect-features-before')[2],
        },
        {
          icon: 'BookmarkTabsImage',
          text: this.getListBlock('promo', 'connect-features-before')[3],
        },
        {
          icon: 'MoneyWithWingsImage',
          text: this.getListBlock('promo', 'connect-features-before')[4],
        },
        {
          icon: 'MoaiImage',
          text: this.getListBlock('promo', 'connect-features-before')[5],
        },
      ];
    },
    getUkaskoItems() {
      return [
        {
          icon: 'LaptopImage',
          text: this.getListBlock('promo', 'connect-features-after')[0],
        },
        {
          icon: 'BellImage',
          text: this.getListBlock('promo', 'connect-features-after')[1],
        },
        {
          icon: 'ChartIncreasingImage',
          text: this.getListBlock('promo', 'connect-features-after')[2],
        },
        {
          icon: 'StarStruckImage',
          text: this.getListBlock('promo', 'connect-features-after')[3],
        },
        {
          icon: 'MoneyBagImage',
          text: this.getListBlock('promo', 'connect-features-after')[4],
        },
        {
          icon: 'BustsInSilhouetteImage',
          text: this.getListBlock('promo', 'connect-features-after')[5],
        },
      ];
    },
  },
  methods: { clsx },
};
</script>

<style scoped lang="scss">
.comparison {
  &-grid {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 70px 0 85px;
    height: 815px;
  }

  &-observer {
    display: flex;
    justify-content: center;

    &--visible {
      .comparison-before-list {
        animation-play-state: running;
      }

      ::v-deep .feature-list--simple {
        animation-play-state: running;

        .feature-list__item {
          animation-play-state: running;
        }
      }

      ::v-deep .feature-list--fancy {
        animation-play-state: running;

        .feature-list__item {
          animation-play-state: running;
        }
      }
    }
  }

  &-before-list {
    margin-right: 16px;
  }

  &__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 25px;
    background: linear-gradient(to bottom, rgba(202, 221, 252, 0) 0%, rgba(255, 255, 255, 0.8) 100%);
  }
}
</style>
